<template>
  <div class="c-chat__fileUploadWrapper">
    <FileUpload
      ref="fileUploadRef"
      :key="chatStore.fileUploadKey"
      class="o-flex__item -grow"
      @onProcessFile="onProcessFile"
      @fileAdded="fileAdded"
      @updateUploadingProgress="updateUploadingProgress"
      @fileUploaded="fileUploaded" />
  </div>
</template>

<script setup>
import {
  onMounted, ref, computed,
} from 'vue'

import constants from '@/constants'
import api from '@/logic/api'
import learningmaterials from '@/logic/learningmaterials'
import { useChatAttachmentsStore } from '@/modules/chat/chatAttachmentsStore'
import { useChatStore } from '@/modules/chat/chatStore'
import { useChatThreadStore } from '@/modules/chat/chatThreadStore'
import FileUpload from '@/modules/chat/components/FileUpload.vue'

const fileUploadRef = ref(null)
const chatStore = useChatStore()
const threadId = computed(() => chatStore.chatThread?.azure_chat_thread_id)
const chatThreadStore = computed(() => {
  if (!threadId.value) return null
  return useChatThreadStore(threadId.value)
})
const chatAttachmentsStore = computed(() => {
  if (!threadId.value) return null
  return useChatAttachmentsStore(threadId.value)
})

const fileUploaded = async (serverId, file) => {
  if (!chatAttachmentsStore.value || !chatThreadStore.value) return

  await chatAttachmentsStore.value.saveAttachmentFile(serverId, file)
  await chatThreadStore.value.updateSortedMessages()
  await chatThreadStore.value.scrollContainerDown()

  chatStore.fileUploadKey = new Date().valueOf()
}

const updateUploadingProgress = async (progress, file) => {
  if (!chatAttachmentsStore.value || !chatThreadStore.value) return
  await chatAttachmentsStore.value.updateAttachmentUploadingProgress(file, progress)
  await chatThreadStore.value.updateSortedMessages()
}

const fileAdded = async (file) => {
  if (!chatAttachmentsStore.value) return
  await chatAttachmentsStore.value.handleSendAttachmentMessage(file)
}

const onProcessFile = async (error, file) => {
  if (error) {
    api.store.commit('notifications/addError', {
      title: api.i18n.t('errors.no_response'),
    })

    setTimeout(async () => {
      if (!chatAttachmentsStore.value || !chatThreadStore.value) return
      await chatAttachmentsStore.value.handleFailureWhenUploading(file.id, constants.CHAT.MESSAGE_ERRORS.FAILED_TO_UPLOAD)
      chatStore.fileUploadKey = new Date().valueOf()

      // Show preview of the file in sender side
      const fileType = learningmaterials.getType({ file_type: file.fileType })
      let fileUrl = file
      if (fileType === constants.LEARNINGMATERIALS.TYPE_DOCUMENT_IMAGE || fileType === constants.LEARNINGMATERIALS.TYPE_AUDIO) {
        fileUrl = URL.createObjectURL(file.file)
      }
      const messageId = chatAttachmentsStore.value.attachments[file.id]
      if (!messageId) {
        return
      }

      const updatedMessage = chatThreadStore.value.updateMessageByAzureId(messageId, {
        metadata: {
          file_url: fileUrl,
        },
      })

      if (!updatedMessage) {
        return
      }

      await chatThreadStore.value.updateSortedMessages()
    }, 100)
  }
}

onMounted(() => {
  chatStore.fileUploadRef = fileUploadRef
})
</script>
